import React from 'react'

export default function SwiperArrow() {
  return (
    <svg width="50" height="50" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 14.5L30 24.5L20 34.5" fill="white" />
      <path d="M20 14.5L30 24.5L20 34.5" stroke="#00323D" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
